<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">アイテム付替</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">Ｐコード</label>
          <div class="list-input-content">
            <input type="text" class="pcode" plessInputTextSub id="txti_Pcode"
              [restrict]="'[P0-9]'" [(ngModel)]="kymw1104Model.pCode" readonly/>
          </div>

          <label class="list-input-title">商品案内用商品名</label>
          <div class="list-input-content">
            <app-text-input id="txti_GuideGoodsName" [subid]="'txti_GuideGoodsName'"
              [displayCountField]="false" [restrict]="'[ -￮]'" [(ngModel)]="kymw1104Model.guideGoodsName"
              class="guide-goods-name" [editable]="false">
            </app-text-input>
          </div>

          <label class="list-input-title">商品案内用規格名</label>
          <div class="list-input-content">
            <app-text-input class="guide-standard-name" id="txti_GuideStandardName" [subid]="'txti_GuideStandardName'"
              [displayCountField]="false" [restrict]="'[ -￮]'" [(ngModel)]="kymw1104Model.guideStandardName"
              [editable]="false">
            </app-text-input>
          </div>
        </div>

        <div>
          <div class="block-row">
            <div class="column-list">
              <div class="layout_center" style="width:130px">
                <label class="header">会員生協</label>
              </div>
              <div class="layout_center" style="width:130px">
                <label class="header">アイテムコード</label>
              </div>
            </div>
            <div class="column-list">
              <div class="layout_center" style="width:130px">
                <label class="header">会員生協</label>
              </div>
              <div class="layout_center" style="width:130px">
                <label class="header">アイテムコード</label>
              </div>
            </div>
          </div>

          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">いばらき</label>
              <div class="list-input-content">
                <select id="cmb_IbarakiItemCode" style="width:130px" #cmb_IbarakiItemCode labelField="ItemCode" [tabindex]="0"
                  [(ngModel)]="kymw1104Model.ibaraki_ItemCode" [disabled]="!kymw1104Model.enabledIbaraki_ItemCode"
                  (change)="eventItemCode_CHANGEHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="kymw1104Model.ibaraki_ItemCodeList">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>

              <label class="list-input-title">とちぎ</label>
              <div class="list-input-content">
                <select id="cmb_TochigiItemCode" #item_code #cmb_TochigiItemCode labelField="ItemCode" [tabindex]="0"
                  [(ngModel)]="kymw1104Model.tochigi_ItemCode" [disabled]="!kymw1104Model.enabledTochigi_ItemCode"
                  (change)="eventItemCode_CHANGEHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="kymw1104Model.tochigi_ItemCodeList">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>

              <label class="list-input-title">ぐんま</label>
              <div class="list-input-content">
                <select id="cmb_GunmaItemCode" #item_code #cmb_GunmaItemCode labelField="ItemCode" [tabindex]="0"
                  [(ngModel)]="kymw1104Model.gunma_ItemCode" [disabled]="!kymw1104Model.enabledGunma_ItemCode"
                  (change)="eventItemCode_CHANGEHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="kymw1104Model.gunma_ItemCodeList">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>

              <label class="list-input-title">ちば</label>
              <div class="list-input-content">
                <select id="cmb_ChibaItemCode" #item_code #cmb_ChibaItemCode labelField="ItemCode" [tabindex]="0"
                  [(ngModel)]="kymw1104Model.chiba_ItemCode" [disabled]="!kymw1104Model.enabledChiba_ItemCode"
                  (change)="eventItemCode_CHANGEHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="kymw1104Model.chiba_ItemCodeList">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>

            </div>

            <div class="column-list">
              <label class="list-input-title">さいたま</label>
              <div class="list-input-content">
                <select id="cmb_SaitamaItemCode" style="width:130px" #item_code #cmb_SaitamaItemCode labelField="ItemCode" [tabindex]="0"
                  [(ngModel)]="kymw1104Model.saitama_ItemCode" [disabled]="!kymw1104Model.enabledSaitama_ItemCode"
                  (change)="eventItemCode_CHANGEHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="kymw1104Model.saitama_ItemCodeList">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>

              <label class="list-input-title">とうきょう</label>
              <div class="list-input-content">
                <select id="cmb_TokyoItemCode" #item_code #cmb_TokyoItemCode labelField="ItemCode" [tabindex]="0"
                  [(ngModel)]="kymw1104Model.tokyo_ItemCode" [disabled]="!kymw1104Model.enabledTokyo_ItemCode"
                  (change)="eventItemCode_CHANGEHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="kymw1104Model.tokyo_ItemCodeList">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>

              <label class="list-input-title">ながの</label>
              <div class="list-input-content">
                <select id="cmb_NaganoItemCode" #item_code #cmb_NaganoItemCode labelField="ItemCode" [tabindex]="0"
                  [(ngModel)]="kymw1104Model.nagano_ItemCode" [disabled]="!kymw1104Model.enabledNagano_ItemCode"
                  (change)="eventItemCode_CHANGEHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="kymw1104Model.nagano_ItemCodeList">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>

              <label class="list-input-title">にいがた</label>
              <div class="list-input-content">
                <select id="cmb_NiigataItemCode" #item_code #cmb_NiigataItemCode labelField="ItemCode" [tabindex]="0"
                  [(ngModel)]="kymw1104Model.niigata_ItemCode" [disabled]="!kymw1104Model.enabledNiigata_ItemCode"
                  (change)="eventItemCode_CHANGEHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="kymw1104Model.niigata_ItemCodeList">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_SetItem" #btn_SetItem class="btn-primary" [disabled]="!kymw1104Model.enabledSetItem"
            (click)="eventSetItem_CLICKHandler(null)" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>